import React from 'react';
import Info from '../Symbols/Info';
import Row from '../Symbols/Row';
import Button from '../Symbols/Button';
import Result from './Result';
import Form from '../Symbols/Form';
import InputSelect from '../Symbols/InputSelect';
import Input from '../Symbols/Input';
import InputCurrency from '../Symbols/InputCurrency';
import Wrapper from '../Symbols/Wrapper';
import { OrdinalVariant, ParentsVariant, NumberOfExpectedChildren } from '../porodne/Options';

const emptyFunc = () => {};

export default props => {
	const {
		validateHandler = emptyFunc,
		changeHandler = emptyFunc,
		errors = {},
		state: { ordinal, numberOfExpectedChildren, parents, child6, child15, child26, income },
		result = null,
		onSubmit,
		reset,
	} = props;

	return (
		<Wrapper>
			<Form onSubmit={onSubmit} title="Kalkulačka – Porodné 2019">
				<InputSelect
					label="Kolikáté dítě se vám má narodit"
					name="ordinal"
					value={ordinal}
					onChange={changeHandler('ordinal')}
					onBlur={validateHandler('ordinal')}
					passedProps={{ 'data-cy': 'ordinal' }}
					select={OrdinalVariant}
					error={errors.ordinal}
				/>

				<InputSelect
					label="Počet očekávaných dětí"
					name="numberOfExpectedChildren"
					value={numberOfExpectedChildren}
					onChange={changeHandler('numberOfExpectedChildren')}
					onBlur={validateHandler('numberOfExpectedChildren')}
					passedProps={{ 'data-cy': 'numberOfExpectedChildren' }}
					select={NumberOfExpectedChildren}
					error={errors.numberOfExpectedChildren}
				/>

				<InputSelect
					label="Počet osob v domácnosti"
					name="parents"
					value={parents}
					onChange={changeHandler('parents')}
					onBlur={validateHandler('parents')}
					passedProps={{ 'data-cy': 'parents' }}
					select={ParentsVariant}
					error={errors.parents}
				/>

				<Input
					label="Počet dalších dětí v rodině ve věku do 6 roků"
					name="child6"
					value={child6}
					type="number"
					onChange={changeHandler('child6')}
					onBlur={validateHandler('child6')}
					passedProps={{ min: 0, step: 1, 'data-cy': 'child6' }}
					error={errors.child6}
				/>

				<Input
					label="Počet dalších dětí v rodině ve věku 6 – 15 roků"
					name="child15"
					value={child15}
					type="number"
					onChange={changeHandler('child15')}
					onBlur={validateHandler('child15')}
					passedProps={{ min: 0, step: 1, 'data-cy': 'child15' }}
					error={errors.child15}
				/>

				<Input
					label="Počet dalších nezaopatřených dětí v rodině ve věku 15 – 26 roků"
					name="child26"
					value={child26}
					type="number"
					onChange={changeHandler('child26')}
					onBlur={validateHandler('child26')}
					passedProps={{ min: 0, step: 1, 'data-cy': 'child26' }}
					error={errors.child26}
				/>

				<InputCurrency
					label="Průměrný měsíční příjem"
					name="income"
					value={income}
					onChange={changeHandler('income')}
					onBlur={validateHandler('income')}
					passedProps={{ min: 0, step: 1, 'data-cy': 'income' }}
					error={errors.income}
				/>

				<Info css={Row}>
					<p>
						Za nezaopatřené dítě se počítá každé dítě do patnácti let, dítě na pracovním úřadě mezi
						patnácti a osmnácti lety a studenti do 26 roků.
					</p>
				</Info>

				<div css={Row}>
					<Button data-cy="submit">Výpočet</Button>
				</div>

				{result && <Result porodne={result} />}
				{result && (
					<div css={Row}>
						<Button onClick={reset} data-cy="reset">
							Nový výpočet
						</Button>
					</div>
				)}
			</Form>
		</Wrapper>
	);
};
